import { ChannelState } from '../enums/channel-state.enum';

export const channelStateText: Record<ChannelState, string> = {
  [ChannelState.RUNNING]: 'Running',
  [ChannelState.PAUSED]: 'Paused',
  [ChannelState.STOPPED]: 'Stopped',
  [ChannelState.FAULTED]: 'Faulted',
};
